import { reactive, toRefs } from "vue";

const state = reactive({
  dialogVisible: false,
  title: "",
  mandatoryFields: [] as string[],
  invalidFields: [] as Record<string, any>[],
  confirmLabel: "Ok",
});

export type ErrorDialogOptions = {
  title?: string;
  mandatoryFields?: string[];
  invalidFields?: Record<string, any>[];
  confirmLabel?: string;
};

export function useErrorDialog() {
  async function show(options: ErrorDialogOptions) {
    state.title = options.title ?? "Error";
    state.mandatoryFields = options.mandatoryFields || [];
    state.invalidFields = options.invalidFields || [];
    state.confirmLabel = options.confirmLabel ?? "Ok";
    state.dialogVisible = true;
  }

  const close = () => {
    state.dialogVisible = false;
  };

  return {
    ...toRefs(state),
    show,
    close,
  };
}
